
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-substract",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 50.44 50.44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Pfad 361","fill":"none"}},[_c('text',{attrs:{"data-name":"-","transform":"translate(19 33)","fill":"#fff","font-size":"30","font-family":"SegoeUI-Light, Segoe UI","font-weight":"300","letter-spacing":".025em"}},[_c('tspan',{staticClass:"icon-substract__text",attrs:{"x":"0","y":"0"}},[_v('-')])]),_c('path',{attrs:{"d":"M25.22 0A25.22 25.22 0 110 25.22 25.22 25.22 0 0125.22 0z"}}),_c('path',{staticClass:"icon-substract__path",attrs:{"d":"M25.22 2A23.145 23.145 0 008.801 8.801 23.145 23.145 0 002 25.22a23.145 23.145 0 006.801 16.419A23.145 23.145 0 0025.22 48.44a23.145 23.145 0 0016.419-6.801A23.145 23.145 0 0048.44 25.22 23.145 23.145 0 0041.64 8.801 23.145 23.145 0 0025.22 2m0-2c13.929 0 25.22 11.291 25.22 25.22 0 13.929-11.291 25.22-25.22 25.22C11.291 50.44 0 39.15 0 25.22 0 11.291 11.291 0 25.22 0z","fill":"#fff"}})])])
          )
        }
      }
    